var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginAvatarPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1085_18530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.13394 7.8401C9.89244 7.8401 11.3226 5.97389 11.3226 4.21568C11.3226 2.45732 9.89244 1.02661 8.13394 1.02661C6.37573 1.02661 4.94531 2.45717 4.94531 4.21553C4.94546 5.97389 6.37587 7.8401 8.13394 7.8401Z",
    fill: "#7F43FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5274 7.87262C9.90878 8.34388 9.13717 8.62439 8.30133 8.62439H7.96566C7.12983 8.62439 6.35806 8.34388 5.73955 7.87262C3.71995 8.1991 2.17773 9.94972 2.17773 12.0613C2.17773 13.2212 4.84417 14.1617 8.1335 14.1617C11.4228 14.1617 14.0893 13.2212 14.0893 12.0613C14.0893 9.94972 12.5469 8.1991 10.5274 7.87262Z",
    fill: "#7F43FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1085_18530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5946,
    height: 14.5946,
    fill: "white",
    transform: "translate(0.835938 0.297729)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginAvatarPurple);
export default __webpack_public_path__ + "static/media/login-avatar-purple.17fdfe7a8e7ef48407c2825f5cf67324.svg";
export { ForwardRef as ReactComponent };